import React, { Component } from "react";
import styled from "styled-components";
import Header from "./Header";
import MessageList from "./ContentWithWs";
import Footer from "./Footer";

export default class ChatBody extends Component {
  // constructor(props) {
  //   super(props);
  // }

  onCloseFromHeader = () => {
    this.props.onClose();
  };

  render() {
    return (
      <Wrapper>
        <Header onClick={this.onCloseFromHeader} />
        <MessageList />
        <Footer />
      </Wrapper>
    );
  }
}
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 275px;
  height: 375px;
  right: 0px;
  bottom: 0px;
  background: white;
  border-radius: 5px;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.2);
  @media (max-width: 600px) {
    position: absolute;
    right: 0px;
    bottom: 0px;
    width: 100%;
    height: 100%;
    background: white;
    border-radius: 5px;
  }
`;



// WEBPACK FOOTER //
// ./src/chat/ChatBody.js